'use client'

import { useEffect } from 'react'

export default function () {
  useEffect(() => {
    if (['ntv.de', 'www.ntv.de'].includes(window.location.hostname)) {
      window.location.replace('https://www.n-tv.de' + window.location.pathname + window.location.search)
    }
  }, [])

  return null
}
